import { View } from "../../../../../core/view/index";
import { Template } from "../../../../../core/template/index";
import { FortumApp } from "../../../../fortumApp";
import { OrderBaseViewData, OrderBaseView } from "../../order/base";
import { OrderItemLike, OrderItem } from "../../../../db/models/decontamination/orderItem";


export default class OrderItemFlipcardView extends OrderBaseView
{
    public template = Template.lazy('/app/views/decontamination/orderItem/flipcard/index.html');   
    public app: FortumApp;
    public data: OrderItemFlipcardViewData;

    public beforeRender(): PromiseLike<void>
    {
        this.data.stateLabels = {
            [OrderItem.STATE_NEW]: this.pgettext('decontamination.OrderItem.state', 'New'),
            [OrderItem.STATE_STARTED]: this.pgettext('decontamination.OrderItem.state', 'Started'),
            [OrderItem.STATE_COMPLETED]: this.pgettext('decontamination.OrderItem.state', 'Completed'),
        }
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {
        return super.afterRender();
    }

    private onCleansingTypesButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false);
        this.app.router.go(`#/order/${this.data.order.uuid}/item/${this.data.id}/detail`, {
            tab: 'cleansing'
        });
    }

    private onMeasuringButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false);
        this.app.router.go(`#/order/${this.data.order.uuid}/item/${this.data.id}/detail`, {
            tab: 'measuring'
        });
    }

    private onOverviewButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false);
        this.app.router.go(`#/order/${this.data.order.uuid}/item/${this.data.id}/detail`, {
            tab: 'overview'
        });
    }
}

export interface OrderItemFlipcardViewData extends OrderBaseViewData, OrderItemLike
{
    stateLabels?: {[key: string]: string};
}